import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { getUserErrorMessage } from "@/lib/error-messages";

const LinkedInCallback = () => {
  const { completeOauthLogin } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const finish = async () => {
      const success = searchParams.get("success") === "1";
      const token = searchParams.get("token") || "";
      const returnUrl = searchParams.get("return_url") || "/dashboard";
      const rawError = searchParams.get("error");
      const linkedExisting = searchParams.get("linked_existing_user") === "1";

      if (!success || !token) {
        const friendlyError =
          rawError === "account_not_found"
            ? "No account is linked to this LinkedIn profile. Please sign up first."
            : "LinkedIn authentication failed. Please try again later.";
        toast.error(getUserErrorMessage(friendlyError, "LinkedIn authentication failed. Please try again later."));
        navigate(`/login?returnUrl=${encodeURIComponent(returnUrl)}`, { replace: true });
        return;
      }

      try {
        await completeOauthLogin(token, returnUrl);
        if (linkedExisting) {
          toast.success("LinkedIn account linked successfully.");
        }
      } catch {
        navigate(`/login?returnUrl=${encodeURIComponent(returnUrl)}`, { replace: true });
      }
    };

    finish();
  }, [completeOauthLogin, navigate, searchParams]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-interview-light">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-b-2 border-interview-blue" />
        <p className="mt-4 text-sm text-slate-700">Finalizing LinkedIn sign-in...</p>
      </div>
    </div>
  );
};

export default LinkedInCallback;
